import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
export function Impressum() {
  return <HelmetProvider data-id="element-165">
      <div className="min-h-screen bg-background text-text-primary font-sans flex flex-col" data-id="element-166">
        <Helmet data-id="element-167">
          <title data-id="element-168">Impressum | Caro Loesel</title>
          <meta name="robots" content="noindex, nofollow" data-id="element-169" />
        </Helmet>

        <main className="flex-grow container mx-auto px-4 py-12 md:py-20 max-w-3xl" data-id="element-170">
          <Link to="/" className="inline-flex items-center text-hotpink hover:text-hotpink/80 transition-colors mb-8 font-medium" data-id="element-171">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-172" />
            Zurück zur Startseite
          </Link>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-8" data-id="element-173">
            Impressum
          </h1>

          <div className="space-y-8 text-text-secondary leading-relaxed" data-id="element-174">
            <section data-id="element-175">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-176">
                Angaben gemäß § 5 TMG
              </h2>
              <p data-id="element-177">
                EXXOTIC Management UG
                <br data-id="element-178" />
                Äußere Bayreuther Str. 59
                <br data-id="element-179" />
                90409 Nürnberg
                <br data-id="element-180" />
                Deutschland
              </p>
            </section>

            <section data-id="element-181">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-182">
                Kontakt
              </h2>
              <p data-id="element-183">
                E-Mail: info@exxotic-management.com
                <br data-id="element-184" />
                Webseite: www.caroloesel.com
              </p>
            </section>

            <section data-id="element-185">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-186">
                Registereintrag
              </h2>
              <p data-id="element-187">
                Eintragung im Handelsregister.
                <br data-id="element-188" />
                Registergericht: Amtsgericht Nürnberg
                <br data-id="element-189" />
                Registernummer: HRB 41546
              </p>
            </section>

            <section data-id="element-190">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-191">
                Umsatzsteuer-ID
              </h2>
              <p data-id="element-192">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz:
                <br data-id="element-193" />
                DE419617625
              </p>
            </section>

            <section data-id="element-194">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-195">
                Steuernummer
              </h2>
              <p data-id="element-196">241/125/92853</p>
            </section>

            <section data-id="element-197">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-198">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p data-id="element-199">
                EXXOTIC Management UG
                <br data-id="element-200" />
                Äußere Bayreuther Str. 59
                <br data-id="element-201" />
                90409 Nürnberg
              </p>
            </section>

            <section data-id="element-202">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-203">
                Haftungsausschluss
              </h2>
              <p className="mb-4" data-id="element-204">
                <strong data-id="element-205">Haftung für Inhalte</strong>
                <br data-id="element-206" />
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
                hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
                ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen
                werden wir diese Inhalte umgehend entfernen.
              </p>
              <p data-id="element-207">
                <strong data-id="element-208">Haftung für Links</strong>
                <br data-id="element-209" />
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar. Eine permanente inhaltliche
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                umgehend entfernen.
              </p>
            </section>
          </div>
        </main>

        <Footer data-id="element-210" />
      </div>
    </HelmetProvider>;
}